import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import API from '../services/api';
import { AccountBox, QrCode } from '@mui/icons-material';
import QRPassDialogsChain from '../components/QRPassDialogsChain';
import TableComponent from '../components/TableComponent';
import { ThumbDown, ThumbUp } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import EventSourceClient from '../services/eventSource';

const PassLogsPage = () => {

  const navigate = useNavigate();

  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [qrDialogOpen, setQrDialogOpen] = useState(false);
  const [forceUpdateCounter, setForceUpdateCounter] = useState(0);
  const [eventSourceClient, setEventSourceClient] = useState(null);
  const [disconnectCount, setDisconnectCount] = useState(0);

  useEffect(() => {
    const client = new EventSourceClient('/passLogs/sse').connect();
    setEventSourceClient(client);

    client.subscribe('passLog', (data) => {
      try {
          console.log('New pass log event');
          // const passLog = JSON.parse(data);
          // Just run data refresh
          updateData();
        } catch (error) {
        console.error('Error during handling message:', error);
      }
    });

    client.subscribe('error', (data) => {
      setDisconnectCount(prevCount => prevCount + 1);
    });

    client.subscribe('close', (data) => {
      setDisconnectCount(prevCount => prevCount + 1);
    });

    client.subscribe('open', (data) => {
      try {
        console.log('EventSourceClient open event');
        setDisconnectCount(0);
      } catch (error) {
        console.error('Error during handling message:', error);
      }
    });

    return () => {
      client.unsubscribe('passLog');
      client.unsubscribe('error');
      client.unsubscribe('close');
      client.unsubscribe('open');
      client.close();
    };
  }, []);

  const columns = [
    { id: 'timestamp', label: 'Timestamp', type: 'timestamp', width: '12%' },
    { id: 'status', label: 'Status', width: '6%', format: (value) => {
      const status = value.toString();
      let tooltipText = '';
      switch (status) {
        case 'success':
          tooltipText = 'Success';
          break;
        case 'early':
          tooltipText = 'Early Date';
          break;
        case 'expired':
          tooltipText = 'Expired';
          break;
        case 'used':
          tooltipText = 'Already Used';
          break;
        case 'failed':
          tooltipText = 'Incorrect QR code';
          break;
        default:
          tooltipText = '';
      }
      const icon = status === 'success' ? <ThumbUp sx={{color: 'green'}}/> : <ThumbDown sx={{color: 'red'}}/>;
      return tooltipText ? <Tooltip title={tooltipText} arrow>{icon}</Tooltip> : icon;
    }},
    { id: 'customer.name', label: 'Name', width: '30%', action: {
        handler: (row) => handleProfileClick(row)
    }},
    { id: 'customer.phone', label: 'Phone', width: '20%'},
    { id: 'qrCode.endDate', label: 'Expire Date', type: 'date', width: '12%'},
    { id: 'qrCode.daysLeft', label: 'Days Left', width: '10%' },
    { id: 'actions', label: '', width: '10%' },
  ];

  const updateData = () => {
    setForceUpdateCounter(prev => prev + 1);
  }

  const getData = async (page, limit) => {
    // PassLogs loading
    const response = await API.get(`/api/passLogs?page=${page}&limit=${limit}`);

    // Data processing
    const processedData = {
      ...response.data,
      rows: response.data.passLogs
    };

    delete processedData.passLogs;

    return processedData;
  };

  const actionsHandlers = {
    actions: [
      {
        name: 'profile',
        label: <AccountBox/>,
        tooltip: 'Customer Profile',
        handler: (row) => handleProfileClick(row)
      },
      {
        name: 'createPass',
        label: <QrCode />,
        tooltip: 'Create Pass',
        handler:(row) => handleCreatePassClick(row)
      }
    ]
  };

  const handleProfileClick = (row) => {
    navigate(`/customers/${row.customer.id}/profile`, {
      state: { from: location.pathname }
    });
  };

  const handleCreatePassClick = (row) => {
    setSelectedCustomer(row?.customer);
    setQrDialogOpen(true);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        padding: '20px',
        margin: 'auto',
        width: '80%'
      }}
    >
      <TableComponent
        columns={columns}
        getData={getData}
        height='80vh'
        forceUpdate={forceUpdateCounter}
        actionsHandlers={actionsHandlers}
      />

      {qrDialogOpen && (
        <QRPassDialogsChain
          customer={selectedCustomer}
          onSuccess={(qrPass) => {
            setSelectedCustomer(null);
            setQrDialogOpen(false);
          }}
          isOpen={qrDialogOpen}
          setIsOpen={setQrDialogOpen}
        />
      )}

    </Box>
  );
};

export default PassLogsPage;
